import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const IconButton = ({
  title = 'Submit',
  className = '',
  type = 'button',
  clickEvent,
  disabled = false,
  icon = '',
  style,
}) => (
  <Button
    type={type}
    className={'insta-button-icon ' + (disabled ? 'disabled ' : '') + className}
    style={{ ...style }}
    onClick={clickEvent}
    disabled={disabled}>
    <i className={'insta-icon-btn ' + icon}></i>{' '}
    <span className="insta-btn-span" dangerouslySetInnerHTML={{ __html: title }}></span>
  </Button>
);

IconButton.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  clickEvent: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  style: PropTypes.object,
};

export default IconButton;
